// Elegant, minimal 3D flight-instrument motifs rendered with CSS 3D transforms.

const Ring = ({ size, tilt, dur, reverse, dot }) => (
  <div
    className="absolute left-1/2 top-1/2"
    style={{ width: `${size}%`, height: `${size}%`, transform: "translate(-50%,-50%)", transformStyle: "preserve-3d" }}
  >
    <div
      className="instr-anim h-full w-full"
      style={{ transformStyle: "preserve-3d", animation: `gyro-spin ${dur}s linear infinite${reverse ? " reverse" : ""}` }}
    >
      <div className="absolute inset-0 rounded-full border border-white/20" style={{ transform: tilt }}>
        {dot && (
          <span
            className="absolute top-1/2 -right-1 h-1.5 w-1.5 rounded-full bg-white/70"
            style={{ transform: "translateY(-50%)", boxShadow: "0 0 10px rgba(255,255,255,0.5)" }}
          />
        )}
      </div>
    </div>
  </div>
);

export const GyroOrb = ({ className = "" }) => (
  <div className={className} aria-hidden="true" data-testid="instrument-gyro">
    <div className="relative w-full aspect-square" style={{ perspective: "900px" }}>
      <div
        className="absolute inset-[10%] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(255,255,255,0.06), transparent 65%)" }}
      />
      <div className="absolute inset-0 rounded-full border border-white/[0.06]" />

      <div className="absolute inset-0" style={{ transformStyle: "preserve-3d" }}>
        <Ring size={100} tilt="rotateX(74deg)" dur={22} dot />
        <Ring size={74} tilt="rotateY(72deg) rotateX(18deg)" dur={17} reverse dot />
        <Ring size={50} tilt="rotateX(28deg) rotateY(52deg)" dur={13} />
      </div>

      <div className="absolute left-1/2 top-1/2 h-12 w-12 -translate-x-1/2 -translate-y-1/2">
        <span className="absolute top-1/2 left-0 h-px w-full -translate-y-1/2 bg-white/25" />
        <span className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-white/25" />
        <span
          className="instr-anim absolute left-1/2 top-1/2 h-2 w-2 rounded-full bg-white/80"
          style={{ animation: "pulse-dot 3s ease-in-out infinite", boxShadow: "0 0 14px rgba(255,255,255,0.6)" }}
        />
      </div>

      <span className="font-mono-x absolute -bottom-3 left-0 text-[9px] tracking-[0.3em] text-white/25">
        ASSETTO · MENTALITÀ
      </span>
      <span className="font-mono-x absolute -bottom-3 left-0 text-[9px] tracking-[0.3em] text-white/25">
        ASSETTO · MENTALITÀ
      </span>
    </div>
  </div>
);

export const RadarDial = ({ className = "" }) => (
  <div className={className} aria-hidden="true" data-testid="instrument-radar">
    <div className="relative w-full aspect-square" style={{ perspective: "1000px" }}>
      <div
        className="instr-anim absolute inset-0"
        style={{ transformStyle: "preserve-3d", animation: "dial-wobble 18s ease-in-out infinite" }}
      >
        <div className="absolute inset-0 rounded-full border border-white/10" />
        <div className="absolute inset-[6%] rounded-full border border-dashed border-white/[0.14]" />
        <div className="absolute inset-[24%] rounded-full border border-white/[0.08]" />
        <div className="absolute inset-[42%] rounded-full border border-white/[0.06]" />

        <div className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-white/[0.06]" />
        <div className="absolute top-1/2 left-0 h-px w-full -translate-y-1/2 bg-white/[0.06]" />

        <div
          className="instr-anim absolute inset-0 rounded-full"
          style={{
            animation: "radar-sweep 5s linear infinite",
            background:
              "conic-gradient(from 0deg, rgba(255,255,255,0.18), rgba(255,255,255,0.02) 42deg, transparent 92deg)",
          }}
        />

        <span
          className="instr-anim absolute left-1/2 top-1/2 h-2.5 w-2.5 rounded-full bg-white/80"
          style={{ animation: "pulse-dot 3s ease-in-out infinite", boxShadow: "0 0 14px rgba(255,255,255,0.6)" }}
        />
      </div>
    </div>
  </div>
);
